module.exports = __webpack_public_path__ + "img/dots.d89e72d8.svg";